import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './AlbumBreadcrumbs.css'
import { tidyAlbumTitle } from '../../utils/string'
import { TIMELINE_SEASONS } from '../../constants'

export default class AlbumBreadcrumbs extends Component {
  renderBreadcrumb = ({ title, href }) => {
    if (!href) {
      return (
        <span key={href} className={classNames.breadcrumb}>
          {title}
        </span>
      )
    }
    return [
      <Link key={href} to={href} className={classNames.breadcrumb}>
        {title}
      </Link>,
      ' '
    ]
  }
  render () {
    const { location } = this.props
    const { path, referrer } = location.query
    if (!path) {
      return null
    }
    const split = path.split('/')
    const crumbs = []
    if (referrer) {
      crumbs.push({
        title: referrer.toUpperCase(),
        href: `/${referrer}`
      })
    }
    for (let i = 0; i !== split.length; i++) {
      const name = split[i]
      // Skip empty or top level crumbs
      if (!name || name === 'COLLECTIONS') {
        continue
      }
      // Skip library crumbs
      if (split.length > 3 && i === 2 && split[1] === 'COLLECTIONS') {
        continue
      }
      // Link to timeline for decades
      if (i === 3 && /^\d\d\d\ds$/.test(name)) {
        crumbs.push({
          title: name,
          href: `/timeline/${name.slice(0, 4)}`
        })
        continue
      }
      // Link to timeline for years
      if (i === 4 && /^\d\d\d\d$/.test(name)) {
        crumbs.push({
          title: name,
          href: `/timeline/${split[3].slice(0, 4)}/${name}`
        })
        continue
      }
      // Link to timeline for seasons
      if (i === 5 && TIMELINE_SEASONS.indexOf(name) !== -1) {
        crumbs.push({
          title: tidyAlbumTitle(name),
          href: `/timeline/${split[3].slice(0, 4)}/${split[4]}/${name}`
        })
        continue
      }
      crumbs.push({
        title: tidyAlbumTitle(name),
        href: `/album?path=${split.slice(0, i + 1).join('/')}${referrer ? '&referrer=' + referrer : ''}`
      })
    }
    return (
      <div className={classNames.breadcrumbs}>
        {crumbs.map(this.renderBreadcrumb)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/album/AlbumBreadcrumbs.js